import { IconButton, Menu, MenuItem } from "@mui/material";
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { ptBR } from '@mui/x-data-grid/locales';
import { MoreVert } from "@mui/icons-material";
import { useState } from "react";
import { cpfMask } from "utils/cpf";
import { IBeneficiaryRetificar } from "../../../types";
import dayjs from "dayjs";

function formatDate(dateToFormat: string) {
  try {
    if (!dayjs(dateToFormat).isValid()) throw new Error();
    return dayjs(dateToFormat).format(`DD/MM/YYYY`);
  } catch (error) {
    return `-`;
  }
}

interface RetificarTableProps {
  data: IBeneficiaryRetificar[];
  onRetificarClick: (beneficiary: IBeneficiaryRetificar) => void;
}

export function RetificarTable({ data, onRetificarClick }: RetificarTableProps) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedRow, setSelectedRow] = useState<string | null>(null);

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>, id: string) => {
    setAnchorEl(event.currentTarget);
    setSelectedRow(id);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedRow(null);
  };

  const handleRetificarClick = () => {
    if (selectedRow !== null) {
      const beneficiary = data[parseInt(selectedRow)];
      onRetificarClick(beneficiary);
    }
    handleMenuClose();
  };

  const columns: GridColDef[] = [
    {
      field: 'nome',
      headerName: 'Nome',
      width: 123.5,
      renderCell: (params) => (
        <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          {params.value}
        </div>
      ),
    },
    {
      field: 'cpfBeneficiario',
      headerName: 'CPF do beneficiário',
      width: 169,
      renderCell: (params) => (
        <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          {cpfMask(params.value)}
        </div>
      ),
    },
    {
      field: 'cpfTitular',
      headerName: 'CPF do titular',
      width: 169,
      renderCell: (params) => (
        <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          {cpfMask(params.value)}
        </div>
      ),
    },
    {
      field: 'tipo',
      headerName: 'Tipo',
      width: 123.5,
      renderCell: (params) => (
        <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          {params.value}
        </div>
      ),
    },
    {
      field: 'dataDemissao',
      headerName: 'Data demissao',
      width: 123.5,
      renderCell: (params) => (
        <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          {!params.value || params.value === '-' ? "-" : formatDate(params.value)}
        </div>
      ),
    },
    {
      field: 'plano',
      headerName: 'Plano',
      width: 123.5,
      renderCell: (params) => (
        <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          {params.value}
        </div>
      ),
    },
    {
      field: 'actions',
      headerName: '',
      width: 49,
      sortable: false,
      renderCell: (params) => (
        <IconButton
          size="small"
          onClick={(e) => handleMenuOpen(e, params.id.toString())}
        >
          <MoreVert />
        </IconButton>
      ),
    },
  ];

  const rowsWithId = data.map((row, index) => ({
    id: index,
    ...row,
  }));

  return (
    <>
      <div style={{ height: 700, width: '100%' }}>
        <DataGrid
          rows={rowsWithId}
          columns={columns}
          localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
          initialState={{
            sorting: {
              sortModel: [{ field: 'nome', sort: 'asc' }],
            },
          }}
          sx={{
            '& .MuiDataGrid-cell': {
              backgroundColor: '#FFFFFF !important',
            },
            '& .MuiDataGrid-columnHeaders': {
              backgroundColor: '#FFFFFF !important',
            },
            '& .MuiDataGrid-root': {
              border: 'none',
            },
            '& .MuiDataGrid-virtualScroller': {
              '&::-webkit-scrollbar': {
                width: '12px',
                height: '12px',
              },
              '&::-webkit-scrollbar-thumb': {
                backgroundColor: '#C1C1C1',
                borderRadius: '8px',
              },
              '&::-webkit-scrollbar-track': {
                backgroundColor: '#F5F5F5',
              },
            },
          }}
        />
      </div>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
      >
        <MenuItem onClick={handleRetificarClick}>Retificar</MenuItem>
        <MenuItem onClick={handleMenuClose}>Ver detalhes</MenuItem>
        <MenuItem onClick={handleMenuClose}>Editar</MenuItem>
      </Menu>
    </>
  );
}
